module.exports = __webpack_public_path__ + "static/arquetipo-splash1-a8bf3e6e4f07577c580cb381d039601b.jpg";